import { OnInit, ElementRef, EventEmitter } from '@angular/core';
var SliderBaseComponent = /** @class */ (function () {
    function SliderBaseComponent() {
        this.step = 1;
        this.minValueChange = new EventEmitter();
        this.maxValueChange = new EventEmitter();
        this.change = new EventEmitter();
    }
    Object.defineProperty(SliderBaseComponent.prototype, "min", {
        get: function () {
            return this._min;
        },
        set: function (min) {
            if (!this.isNumber(this.minValue)) {
                this._minValue = min;
            }
            this._min = min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderBaseComponent.prototype, "max", {
        get: function () {
            return this._max;
        },
        set: function (max) {
            if (!this.isNumber(this.maxValue)) {
                this._maxValue = max;
            }
            this._max = max;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderBaseComponent.prototype, "minValue", {
        get: function () {
            return this._minValue;
        },
        set: function (minValue) {
            if (!this.isNumber(minValue)) {
                // this.minValueChange.emit(this.minValue);
                return;
            }
            if (minValue < this.min) {
                this._minValue = this.min;
            }
            else if (this._minValue !== minValue) {
                this._minValue = minValue;
            }
            else {
                return;
            }
            this.value1 = minValue;
            this.sliderValueChange();
            this.minValueChange.emit(this.minValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderBaseComponent.prototype, "maxValue", {
        get: function () {
            return this._maxValue;
        },
        set: function (maxValue) {
            if (!this.isNumber(maxValue)) {
                // this.maxValueChange.emit(this.maxValue);
                return;
            }
            if (!this.isNumber(maxValue) || maxValue > this.max) {
                this._maxValue = this.max;
            }
            else if (this.maxValue !== maxValue) {
                this._maxValue = maxValue;
            }
            else {
                return;
            }
            this.value2 = maxValue;
            this.sliderValueChange();
            this.maxValueChange.emit(this.maxValue);
        },
        enumerable: true,
        configurable: true
    });
    SliderBaseComponent.prototype.ngOnInit = function () {
        if (this.minValue) {
            this.minValue = null;
        }
        if (this.maxValue) {
            this.maxValue = null;
        }
        this.value1 = this.minValue;
        this.value2 = this.maxValue;
        this.sliderValueChange();
    };
    SliderBaseComponent.prototype.sliderValueChange = function () {
        if (this.value1 > this.value2) {
            this.minValue = this.value2;
            this.maxValue = this.value1;
        }
        else {
            this.minValue = this.value1;
            this.maxValue = this.value2;
        }
        var fullLength = this.max - this.min;
        var fillStart = (this.minValue - this.min) / fullLength * 100;
        var fillWidth = (this.maxValue - this.minValue) / fullLength * 100;
        this.sliderFill.nativeElement.style.width = fillWidth + '%';
        this.sliderFill.nativeElement.style.left = fillStart + '%';
    };
    SliderBaseComponent.prototype.isNumber = function (n) {
        if (n === null || n === undefined) {
            return false;
        }
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    return SliderBaseComponent;
}());
export { SliderBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/slider-base/slider-base.component.ts.pre-build-optimizer.js